import { setSew } from '../lib/sewStore';

// which layers the map shows: manholes / pipes (SWMM), sewer water on the terrain, river high water
const PRESETS = [['pNet', { net: true, sew: false, river: false }], ['pRiver', { net: false, sew: false, river: true }], ['pAll', { net: true, sew: true, river: true }]];

export function SewView({ t, s }) {
  const v = s.view, set = (p) => setSew({ view: { ...v, ...p }, on: true }), fl = s.flood || {};
  const LAY = [['net', t.flLayNet, !!s.res && !s.res.error], ['only', t.flLayOnly, !!s.res && !s.res.error && v.net], ['sew', t.flLaySew, !!fl.sew], ['river', t.flLayRiver, !!fl.river]];
  return (
    <div className="sew-view" data-testid="sew-view">
      <b>{t.flView}</b>
      <div className="row sew-view-pre">
        {PRESETS.map(([k, p]) => <button key={k} type="button" className={`chip${Object.entries(p).every(([a, b]) => v[a] === b) ? ' on' : ''}`} data-testid={`sew-view-${k}`} onClick={() => set(p)}>{t[`flView_${k}`]}</button>)}
      </div>
      {LAY.map(([k, lb, ok]) => (
        <label key={k} className={`row${ok ? '' : ' muted'}`}><input type="checkbox" data-testid={`sew-view-${k}`} disabled={!ok} checked={ok && !!v[k]} onChange={(e) => set({ [k]: e.target.checked })} /> {lb}</label>
      ))}
    </div>
  );
}
